import { useCallback, useState, useEffect } from "react";

import { useUser } from "utils/hooks";
import API from "utils/api";

export default function useCommentReplies(active, type, id, parentId) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(() => active);

  const fetchCommentReplies = useCallback(async () => {
    setLoading(true);

    const { response, data } = await API.fetchComments(token, type, id, 0, { parent: parentId });

    if (response.ok) {
      setResult(data);
      setLoading(false);
    } else {
      console.error(data);
    }
  }, [type, id]);

  useEffect(() => {
    if (active) {
      fetchCommentReplies();
    }
  }, [active, type, id, parentId]);

  return {
    loading,
    reload: fetchCommentReplies,
    comments: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}

